import * as React from 'react';
import './Nav.css'
import { NavLinkList } from '../nav-link-list/NavLinkList';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Container } from 'reactstrap';
import * as ReactCSSTransitionGroup from 'react-addons-css-transition-group';

type State = {
  show: boolean,
  isOpen: boolean
}

export class Navigation extends React.Component<{}, State> {


  constructor( props: {}, context: any ) {
    super( props, context );

    this.scrollHandler = this.scrollHandler.bind(this);
    this.toggle = this.toggle.bind(this);

    this.state = {
      show: false,
      isOpen: false
    };
  }

  componentDidMount(): void {
    window.addEventListener( 'scroll', this.scrollHandler );
  }

  componentWillUnmount(): void {
    window.removeEventListener( 'scroll', this.scrollHandler );
  }

  scrollHandler(event: any) {
    this.setState({ show: window.scrollY > window.innerHeight - 5 });
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render(){
    return (

      <ReactCSSTransitionGroup
        transitionName="nav"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}>
        { this.state.show && (
          <Navbar fixed="top" light toggleable key="navbar">
            <Container>
              <div className="nav-row">
                <NavbarBrand href="/">Muotoilutoimisto Kairo</NavbarBrand>
                <NavbarToggler right onClick={this.toggle}/>
              </div>
              <Collapse isOpen={this.state.isOpen} navbar>
                <NavLinkList type="nav"/>
              </Collapse>
            </Container>
          </Navbar>
        )}
      </ReactCSSTransitionGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/nav/Nav.tsx